"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabBarStyle1 = void 0;
var react_1 = __importDefault(require("react"));
var useScrollBar_1 = require("../../../utils/customHooks/useScrollBar");
var Buttons_1 = require("../../../components/Buttons");
var index_styled_1 = require("./index.styled");
var _EXPORTS_1 = require("../../../utils/_EXPORTS");
var DropdownSingle_1 = require("../../../components/Dropdowns/DropdownSingle");
var mixins_1 = require("../../../themes/mixins");
var Typo2_1 = require("../Typo2");
var phosphor_react_1 = require("phosphor-react");
var colors_1 = require("../../themes/colors");
var icons_1 = require("../../../icons");
var __1 = require("../../..");
var Base = function (_a) {
    var id = _a.id, options = _a.options, valueProp = _a.value, onChange = _a.onChange, style = _a.style, errorTabs = _a.errorTabs, disabledTabs = _a.disabledTabs, _b = _a.tabBarStyle, tabBarStyle = _b === void 0 ? '1' : _b, saveValueAsString = _a.saveValueAsString, _c = _a.black, black = _c === void 0 ? false : _c, M = _a.M, S = _a.S, _size = _a.size //use any one of these 3
    ;
    var size = _size || (S ? 'S' : 'M'); //defaults to M
    var value = saveValueAsString ? options.find(function (d) { return d.value === valueProp; }) : valueProp;
    var _d = (0, useScrollBar_1.useScrollBar)(), scrollContainerRef = _d.scrollContainerRef, scrollX = _d.scrollX, scrollIsAtEnd = _d.scrollIsAtEnd, scrollIsAtStart = _d.scrollIsAtStart, slide = _d.slide;
    var handleClick = function (v) {
        onChange && onChange(id, saveValueAsString ? v.value : v);
    };
    var genIconInTab = function (iconName) {
        var IconComp = icons_1.icons[iconName];
        if (!IconComp)
            return null;
        //else
        return react_1.default.createElement(IconComp, { weight: 'bold', size: 16 });
    };
    return (react_1.default.createElement(index_styled_1.TabBarStyled, { size: size, style: style },
        react_1.default.createElement(index_styled_1.TabBarContainerStyled, { id: id },
            !scrollIsAtStart && (react_1.default.createElement(index_styled_1.StyledDirectionButtons, { left: true },
                react_1.default.createElement(Buttons_1.ButtonGhost, { S: true, icon: 'CaretLeft', style: { height: '100%' }, onClick: function () { return slide("left"); } }))),
            react_1.default.createElement("div", { ref: scrollContainerRef, style: { maxWidth: '100%', height: '100%', overflow: 'hidden' } },
                react_1.default.createElement(index_styled_1.TabBarRowStyled, { id: id, translateX: scrollX }, options.map(function (op) {
                    var tabHasError = errorTabs && errorTabs.some(function (tab) { return tab.value === op.value; });
                    var tabIsDisabled = disabledTabs && disabledTabs.some(function (tab) { return tab.value === op.value; });
                    var tabIsActive = value && op.value === value.value;
                    return (react_1.default.createElement(index_styled_1.TabBarTabWrapper, { tabBarStyle: tabBarStyle, key: op.value, active: tabIsActive, error: tabHasError, disabled: tabIsDisabled, black: black },
                        react_1.default.createElement(index_styled_1.TabBarTabStyled, { size: size, active: tabIsActive, error: tabHasError, disabled: tabIsDisabled, tabBarStyle: tabBarStyle, onClick: function () { return handleClick(op); }, black: black },
                            react_1.default.createElement("div", { style: { display: 'flex', alignItems: 'center', gap: '0.4rem' } },
                                op.icon && genIconInTab(op.icon),
                                op.display &&
                                    react_1.default.createElement(index_styled_1.STYLED_TYPO, { capitalize: true }, op.display),
                                op.message &&
                                    react_1.default.createElement("div", { style: { background: __1.colors2.black, padding: "0.3rem 0.5rem", borderRadius: "2px" } },
                                        react_1.default.createElement(Typo2_1.UI_TAG, { style: { color: __1.colors2.white } }, op.message))),
                            tabHasError && react_1.default.createElement(index_styled_1.StyledDot, { active: tabIsActive, error: tabHasError, tabBarStyle: tabBarStyle }))));
                }))),
            !scrollIsAtEnd && (react_1.default.createElement(index_styled_1.StyledDirectionButtons, { right: true },
                react_1.default.createElement(Buttons_1.ButtonGhost, { S: true, icon: 'CaretRight', style: { height: '100%' }, onClick: function () { return slide("right"); } }))))));
};
var TabBarStyle1 = function (props) {
    var _a = props.placeholder, placeholder = _a === void 0 ? 'Select An Option' : _a;
    var screenWidth = (0, _EXPORTS_1.useScreenWidth)();
    var isDesktop = screenWidth >= (0, mixins_1.getBreakPoint)("sm");
    return (props.responsive && !isDesktop
        ? (react_1.default.createElement(DropdownSingle_1.DropdownSingle, __assign({}, props, { genCustomSelectComp: function () {
                var _a, _b;
                return react_1.default.createElement(CustomSelectComp, { saveValueAsString: props.saveValueAsString, value: props.value, title: props.title, placeholder: placeholder, display: props.saveValueAsString
                        ? (_a = props.options.find(function (d) { return d.value === props.value; })) === null || _a === void 0 ? void 0 : _a.display
                        : (_b = props.value) === null || _b === void 0 ? void 0 : _b.display });
            } })))
        : (react_1.default.createElement(Base, __assign({}, props, { tabBarStyle: "1" }))));
};
exports.TabBarStyle1 = TabBarStyle1;
var CustomSelectComp = function (_a) {
    var display = _a.display, title = _a.title, placeholder = _a.placeholder;
    return (react_1.default.createElement(index_styled_1.StyledWrapper, null,
        react_1.default.createElement("div", null,
            react_1.default.createElement(Typo2_1.UI_TAG, { style: { color: colors_1.colors.grey40 } }, title),
            react_1.default.createElement(Typo2_1.UI_BODY_SEMIBOLD, { capitalize: true, style: { color: display ? colors_1.colors.black : colors_1.colors.grey60 } }, display || placeholder)),
        react_1.default.createElement(phosphor_react_1.List, { size: 18, weight: "bold" })));
};
